



























import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import { TbMember } from '@/http';
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
import Bus from '@/common/util/bus';
@Component({
    components: {
    },
})
export default class scanPanel extends Vue {
    public $refs: {
        barcode:HTMLFormElement;
    };

    @Prop({
        default:false
    })
    show:Boolean = false;

    /**无效优惠券 */
    @Prop({
        default:false
    })
    isOff:Boolean;
/* 重置当前页 */

    fmoney = fmoney;

    
    created() {
       
    } 
    
    mounted() { 
    }


    closeFun(){
        this.$emit("closeFun");
}
    resetScan(){
        this.$emit("resetScan");

    }
    getScan(){
        Bus.$emit('watchCouponScan',true);
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/scanPanel.vue